import { defineNotificationCategory, requireFields } from './types';

export const invitesDescriptor = defineNotificationCategory('invites', {
  isAvailable: requireFields('inviteeName', 'organizationDisplayName'),
  actionUrl: (data, organizationId) =>
    `/org-id/${organizationId}/settings/user-management/users/${data.inviteeUserId}`,
  serverCopy: {
    titleKey: 'invites.title',
    bodyKey: 'invites.body',
    values: (data) => ({ inviteeName: data.inviteeName, org: data.organizationDisplayName }),
  },
  pills: () => ['Invite'],
});

export const jiraReauthDescriptor = defineNotificationCategory('jira_reauth', {
  isAvailable: requireFields('stage'),
  actionUrl: (_data, organizationId) => `/org-id/${organizationId}/settings/work-integrations`,
  serverCopy: {
    titleKey: (data) => `jiraReauth.${data.stage}.title`,
    bodyKey: (data) => `jiraReauth.${data.stage}.body`,
    values: () => ({}),
  },
  pills: () => ['Jira'],
});
